import { useState, useMemo } from 'react';
import ClientShell from './ClientShell';
import { navigate } from './api';

const styles = {
  container: {
    padding: '24px',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    marginBottom: '32px',
  },
  headerTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#FFF',
    marginBottom: '8px',
  },
  headerSubtitle: {
    fontSize: '14px',
    color: '#8B92A5',
  },
  searchContainer: {
    marginBottom: '32px',
  },
  searchWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    padding: '12px 16px',
    transition: 'all 0.2s',
  },
  searchIcon: {
    fontSize: '18px',
    color: '#8B92A5',
  },
  searchInput: {
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    color: '#FFF',
    fontSize: '14px',
    outline: 'none',
    fontFamily: 'inherit',
  },
  searchInputPlaceholder: {
    color: '#5A6175',
  },
  popularSection: {
    marginBottom: '40px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#FFF',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  popularGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
  },
  articleCard: {
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    padding: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  articleCardHover: {
    borderColor: '#0057FF',
    backgroundColor: '#1A2332',
    boxShadow: '0 4px 12px rgba(0, 87, 255, 0.1)',
  },
  articleIcon: {
    fontSize: '28px',
    marginBottom: '12px',
  },
  articleTitle: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#FFF',
    marginBottom: '8px',
    lineHeight: '1.4',
  },
  articleExcerpt: {
    fontSize: '13px',
    color: '#BBBEC7',
    marginBottom: '12px',
    flex: 1,
    lineHeight: '1.5',
  },
  articleMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '12px',
    color: '#8B92A5',
  },
  readTime: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  tags: {
    display: 'flex',
    gap: '4px',
    flexWrap: 'wrap',
    marginTop: '12px',
  },
  tag: {
    display: 'inline-block',
    backgroundColor: '#1A2332',
    color: '#0057FF',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: '600',
  },
  categoriesSection: {
    marginBottom: '40px',
  },
  categoryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
  },
  categoryBox: {
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  categoryHeader: {
    backgroundColor: '#1A2332',
    padding: '16px',
    borderBottom: '1px solid #2A3444',
  },
  categoryTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#FFF',
    marginBottom: '4px',
  },
  categoryCount: {
    fontSize: '12px',
    color: '#8B92A5',
  },
  categoryArticles: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  categoryArticleItem: {
    padding: '12px',
    backgroundColor: '#0A0F1D',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    border: '1px solid transparent',
  },
  categoryArticleItemHover: {
    borderColor: '#0057FF',
    backgroundColor: '#0F1729',
  },
  categoryArticleTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#FFF',
    marginBottom: '4px',
  },
  categoryArticleDesc: {
    fontSize: '12px',
    color: '#8B92A5',
  },
  tierBadge: {
    display: 'inline-block',
    marginTop: '8px',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: '700',
    backgroundColor: '#C084FC',
    color: '#0A0F1D',
  },
  tierBadgeSmb: {
    backgroundColor: '#00D4AA',
  },
  tierBadgeMidMarket: {
    backgroundColor: '#FFB347',
  },
  tierBadgeEnterprise: {
    backgroundColor: '#FF6B6B',
  },
  videoSection: {
    marginBottom: '40px',
  },
  videoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '16px',
  },
  videoCard: {
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  videoCardHover: {
    borderColor: '#0057FF',
    transform: 'translateY(-2px)',
  },
  videoThumbnail: {
    backgroundColor: '#1A2332',
    width: '100%',
    height: '140px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  playButton: {
    fontSize: '48px',
    color: '#0057FF',
    transition: 'all 0.2s',
  },
  videoMeta: {
    padding: '16px',
  },
  videoTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#FFF',
    marginBottom: '4px',
  },
  videoDuration: {
    fontSize: '12px',
    color: '#8B92A5',
  },
  faqSection: {
    marginBottom: '40px',
  },
  faqItem: {
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    marginBottom: '12px',
    overflow: 'hidden',
  },
  faqQuestion: {
    padding: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'all 0.2s',
    userSelect: 'none',
  },
  faqQuestionHover: {
    backgroundColor: '#1A2332',
  },
  faqQuestionText: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#FFF',
    flex: 1,
  },
  faqToggle: {
    fontSize: '18px',
    color: '#0057FF',
    fontWeight: '700',
    minWidth: '24px',
    textAlign: 'right',
  },
  faqAnswer: {
    padding: '16px',
    backgroundColor: '#0A0F1D',
    borderTop: '1px solid #2A3444',
    fontSize: '13px',
    color: '#BBBEC7',
    lineHeight: '1.6',
  },
  supportSection: {
    backgroundColor: '#1A2332',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    padding: '24px',
    textAlign: 'center',
    marginBottom: '40px',
  },
  supportSectionTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#FFF',
    marginBottom: '12px',
  },
  supportSectionText: {
    fontSize: '14px',
    color: '#BBBEC7',
    marginBottom: '16px',
    lineHeight: '1.5',
  },
  supportButton: {
    backgroundColor: '#0057FF',
    color: '#FFF',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  supportButtonHover: {
    backgroundColor: '#0047D4',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0, 87, 255, 0.3)',
  },
  emptyState: {
    textAlign: 'center',
    padding: '48px 24px',
    color: '#8B92A5',
  },
  emptyStateIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  detailModal: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(10, 15, 29, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '24px',
  },
  detailContent: {
    backgroundColor: '#0F1729',
    border: '1px solid #2A3444',
    borderRadius: '8px',
    maxWidth: '700px',
    width: '100%',
    maxHeight: '80vh',
    overflowY: 'auto',
    padding: '32px',
  },
  detailHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
  },
  detailTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#FFF',
    flex: 1,
  },
  closeButton: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '24px',
    color: '#8B92A5',
    cursor: 'pointer',
    padding: '0',
    transition: 'color 0.2s',
  },
  detailMeta: {
    display: 'flex',
    gap: '16px',
    marginBottom: '24px',
    fontSize: '12px',
    color: '#8B92A5',
    paddingBottom: '16px',
    borderBottom: '1px solid #2A3444',
  },
  detailBody: {
    fontSize: '14px',
    color: '#BBBEC7',
    lineHeight: '1.8',
  },
};

// Hardcoded knowledge base articles
const KNOWLEDGE_BASE = {
  smb: {
    'Getting Started': [
      {
        id: 'gs-1',
        title: 'Welcome to Talk Australia Portal',
        excerpt: 'Get started with your new business communication platform',
        content: 'Welcome to Talk Australia! This comprehensive guide will help you navigate the portal and get the most out of your services. Our platform is designed to provide you with seamless communication solutions for your business.',
        readTime: '5 min',
        tags: ['onboarding', 'basics'],
        icon: '🚀',
      },
      {
        id: 'gs-2',
        title: 'Setting Up Your Account',
        excerpt: 'Complete account configuration and team setup',
        content: 'Complete guide to setting up your Talk Australia account. Configure your domain settings, add team members, and establish your communication preferences. Follow our step-by-step wizard for a smooth onboarding experience.',
        readTime: '8 min',
        tags: ['setup', 'account'],
        icon: '⚙️',
      },
      {
        id: 'gs-3',
        title: 'First Steps: Dashboard Tour',
        excerpt: 'Navigate the main dashboard and core features',
        content: 'Take a tour of your dashboard and learn about key features available to you. Understand your current service status, access important notifications, and explore the main navigation menu.',
        readTime: '4 min',
        tags: ['dashboard', 'navigation'],
        icon: '📊',
      },
    ],
    'Email & Microsoft 365': [
      {
        id: 'em-1',
        title: 'Email Setup and Configuration',
        excerpt: 'Configure your business email through Talk Australia',
        content: 'Learn how to set up your business email accounts. This guide covers email configuration, authentication, and best practices for email management. Ensure your team can send and receive emails reliably.',
        readTime: '6 min',
        tags: ['email', 'configuration'],
        icon: '📧',
      },
      {
        id: 'em-2',
        title: 'Microsoft 365 Integration',
        excerpt: 'Connect Office 365 to your Talk Australia services',
        content: 'Integrate Microsoft 365 services with your Talk Australia account. This guide helps you connect Teams, SharePoint, and other Microsoft services for enhanced collaboration.',
        readTime: '7 min',
        tags: ['microsoft365', 'integration'],
        icon: '☁️',
      },
    ],
    'Internet & NBN': [
      {
        id: 'inet-1',
        title: 'NBN Connection Setup',
        excerpt: 'Configure your National Broadband Network service',
        content: 'Setting up your NBN connection through Talk Australia. Understand different connection types, speeds available, and how to monitor your connection status.',
        readTime: '6 min',
        tags: ['nbn', 'internet'],
        icon: '🌐',
      },
      {
        id: 'inet-2',
        title: 'Optimizing Internet Performance',
        excerpt: 'Tips for maximizing your internet speed and reliability',
        content: 'Learn best practices for maintaining optimal internet performance. Includes bandwidth management, device placement, and troubleshooting connectivity issues.',
        readTime: '5 min',
        tags: ['internet', 'performance'],
        icon: '⚡',
      },
    ],
    'Basic Security': [
      {
        id: 'sec-1',
        title: 'Password Security Best Practices',
        excerpt: 'Protect your account with strong passwords',
        content: 'Essential password security guidelines for your Talk Australia account. Learn about password requirements, two-factor authentication, and security best practices.',
        readTime: '4 min',
        tags: ['security', 'passwords'],
        icon: '🔒',
      },
      {
        id: 'sec-2',
        title: 'Two-Factor Authentication Setup',
        excerpt: 'Enable 2FA for enhanced account security',
        content: 'Step-by-step guide to enabling two-factor authentication. Protect your account from unauthorized access with an additional security layer.',
        readTime: '3 min',
        tags: ['security', '2fa'],
        icon: '🔐',
      },
    ],
    'Phone Systems': [
      {
        id: 'phone-1',
        title: 'VoIP Phone System Overview',
        excerpt: 'Understanding Talk Australia VoIP services',
        content: 'Comprehensive overview of VoIP phone systems. Learn about call routing, voicemail, and call management features available in your service.',
        readTime: '7 min',
        tags: ['voip', 'phone'],
        icon: '☎️',
      },
      {
        id: 'phone-2',
        title: 'Setting Up Extension Numbers',
        excerpt: 'Configure phone extensions for your team',
        content: 'Create and configure phone extensions for your team members. Manage call routing and set up auto-attendant features.',
        readTime: '5 min',
        tags: ['voip', 'extensions'],
        icon: '📱',
      },
    ],
    'Troubleshooting': [
      {
        id: 'ts-1',
        title: 'Common Service Issues',
        excerpt: 'Quick solutions for frequent problems',
        content: 'Troubleshooting guide for common issues. Includes steps to resolve connectivity problems, account access issues, and service disruptions.',
        readTime: '6 min',
        tags: ['troubleshooting', 'support'],
        icon: '🔧',
      },
      {
        id: 'ts-2',
        title: 'How to Check Service Status',
        excerpt: 'Monitor your service health and uptime',
        content: 'Learn how to check your service status and access incident reports. Monitor uptime metrics and service performance.',
        readTime: '3 min',
        tags: ['monitoring', 'status'],
        icon: '📈',
      },
    ],
  },
  'mid-market': {
    // All SMB categories plus these additions
    ...Object.keys(
      {
        'Getting Started': true,
        'Email & Microsoft 365': true,
        'Internet & NBN': true,
        'Basic Security': true,
        'Phone Systems': true,
        'Troubleshooting': true,
      }
    ).reduce(
      (acc, key) => ({
        ...acc,
        [key]:
          {
            'Getting Started': {
              'Getting Started': [
                {
                  id: 'gs-1',
                  title: 'Welcome to Talk Australia Portal',
                  excerpt: 'Get started with your new business communication platform',
                  content:
                    'Welcome to Talk Australia! This comprehensive guide will help you navigate the portal and get the most out of your services.',
                  readTime: '5 min',
                  tags: ['onboarding', 'basics'],
                  icon: '🚀',
                },
              ],
              'Email & Microsoft 365': [
                {
                  id: 'em-1',
                  title: 'Email Setup and Configuration',
                  excerpt: 'Configure your business email through Talk Australia',
                  content:
                    'Learn how to set up your business email accounts. This guide covers email configuration, authentication, and best practices.',
                  readTime: '6 min',
                  tags: ['email', 'configuration'],
                  icon: '📧',
                },
              ],
              'Internet & NBN': [
                {
                  id: 'inet-1',
                  title: 'NBN Connection Setup',
                  excerpt: 'Configure your National Broadband Network service',
                  content:
                    'Setting up your NBN connection through Talk Australia. Understand different connection types and speeds available.',
                  readTime: '6 min',
                  tags: ['nbn', 'internet'],
                  icon: '🌐',
                },
              ],
              'Basic Security': [
                {
                  id: 'sec-1',
                  title: 'Password Security Best Practices',
                  excerpt: 'Protect your account with strong passwords',
                  content:
                    'Essential password security guidelines for your Talk Australia account. Learn about password requirements and 2FA.',
                  readTime: '4 min',
                  tags: ['security', 'passwords'],
                  icon: '🔒',
                },
              ],
              'Phone Systems': [
                {
                  id: 'phone-1',
                  title: 'VoIP Phone System Overview',
                  excerpt: 'Understanding Talk Australia VoIP services',
                  content:
                    'Comprehensive overview of VoIP phone systems. Learn about call routing and voicemail.',
                  readTime: '7 min',
                  tags: ['voip', 'phone'],
                  icon: '☎️',
                },
              ],
              'Troubleshooting': [
                {
                  id: 'ts-1',
                  title: 'Common Service Issues',
                  excerpt: 'Quick solutions for frequent problems',
                  content:
                    'Troubleshooting guide for common issues. Includes steps to resolve connectivity problems.',
                  readTime: '6 min',
                  tags: ['troubleshooting', 'support'],
                  icon: '🔧',
                },
              ],
            },
          }[key] || [],
      }),
      {}
    ),
    'Network Management': [
      {
        id: 'nm-1',
        title: 'Network Configuration and Routing',
        excerpt: 'Advanced network setup for enterprise networks',
        content:
          'Configure your network infrastructure with Talk Australia. Learn about routing, VLANs, and network segmentation.',
        readTime: '9 min',
        tags: ['networking', 'advanced'],
        icon: '🔗',
      },
      {
        id: 'nm-2',
        title: 'Bandwidth Management Policies',
        excerpt: 'Optimize bandwidth usage across your organization',
        content:
          'Implement bandwidth management and QoS policies. Ensure critical services get priority bandwidth allocation.',
        readTime: '7 min',
        tags: ['networking', 'performance'],
        icon: '⚙️',
      },
    ],
    'Cloud Infrastructure': [
      {
        id: 'ci-1',
        title: 'Hybrid Cloud Deployment',
        excerpt: 'Integrate cloud services with on-premises systems',
        content:
          'Deploy hybrid cloud solutions. Connect your on-premises infrastructure with Talk Australia cloud services.',
        readTime: '10 min',
        tags: ['cloud', 'infrastructure'],
        icon: '☁️',
      },
      {
        id: 'ci-2',
        title: 'Cloud Backup and Recovery',
        excerpt: 'Implement reliable backup and disaster recovery',
        content:
          'Set up cloud-based backup solutions. Ensure your data is protected with automated recovery procedures.',
        readTime: '8 min',
        tags: ['cloud', 'backup'],
        icon: '💾',
      },
    ],
    'Compliance': [
      {
        id: 'comp-1',
        title: 'PCI DSS Compliance Guide',
        excerpt: 'Payment Card Industry Data Security Standard basics',
        content:
          'Overview of PCI DSS requirements for payment processing. Ensure your systems meet compliance standards.',
        readTime: '8 min',
        tags: ['compliance', 'security'],
        icon: '📋',
      },
      {
        id: 'comp-2',
        title: 'HIPAA for Healthcare Organizations',
        excerpt: 'Health Insurance Portability and Accountability Act',
        content:
          'HIPAA compliance essentials. Protect patient data and maintain regulatory compliance for healthcare services.',
        readTime: '9 min',
        tags: ['compliance', 'healthcare'],
        icon: '🏥',
      },
    ],
    'Advanced VoIP': [
      {
        id: 'av-1',
        title: 'SIP Trunking Configuration',
        excerpt: 'Set up SIP trunks for enterprise communications',
        content:
          'Configure SIP trunks for advanced VoIP. Understand session initiation protocol and call routing.',
        readTime: '10 min',
        tags: ['voip', 'sip'],
        icon: '☎️',
      },
      {
        id: 'av-2',
        title: 'Call Center Integration',
        excerpt: 'Implement contact center solutions',
        content:
          'Set up call center features. Configure IVR, call queuing, and agent management systems.',
        readTime: '11 min',
        tags: ['voip', 'callcenter'],
        icon: '🎧',
      },
    ],
    'Disaster Recovery': [
      {
        id: 'dr-1',
        title: 'Business Continuity Planning',
        excerpt: 'Develop disaster recovery strategies',
        content:
          'Create comprehensive disaster recovery plans. Ensure business continuity during service interruptions.',
        readTime: '12 min',
        tags: ['disaster-recovery', 'planning'],
        icon: '🛡️',
      },
      {
        id: 'dr-2',
        title: 'Failover and Redundancy Setup',
        excerpt: 'Implement automatic failover mechanisms',
        content:
          'Configure redundant systems and automatic failover. Minimize downtime with secondary systems.',
        readTime: '10 min',
        tags: ['disaster-recovery', 'redundancy'],
        icon: '🔄',
      },
    ],
  },
  enterprise: {
    // All previous tiers + these additions
    'Getting Started': [
      {
        id: 'gs-1',
        title: 'Welcome to Talk Australia Portal',
        excerpt: 'Get started with your new business communication platform',
        content:
          'Welcome to Talk Australia! This comprehensive guide will help you navigate the portal and get the most out of your services.',
        readTime: '5 min',
        tags: ['onboarding', 'basics'],
        icon: '🚀',
      },
    ],
    'Cisco Meraki Deployment': [
      {
        id: 'cm-1',
        title: 'Meraki Dashboard Configuration',
        excerpt: 'Manage Cisco Meraki network infrastructure',
        content:
          'Configure and manage Cisco Meraki devices. Set up switches, access points, and firewalls through the cloud dashboard.',
        readTime: '12 min',
        tags: ['cisco-meraki', 'network'],
        icon: '🖥️',
      },
      {
        id: 'cm-2',
        title: 'Advanced Network Segmentation',
        excerpt: 'Implement enterprise-grade network segmentation',
        content:
          'Deploy VLANs, firewall rules, and network policies. Segment your network for security and performance.',
        readTime: '14 min',
        tags: ['cisco-meraki', 'security'],
        icon: '🔐',
      },
    ],
    'SD-WAN': [
      {
        id: 'sdwan-1',
        title: 'SD-WAN Architecture Overview',
        excerpt: 'Software-defined WAN for enterprise networks',
        content:
          'Understand SD-WAN architecture. Implement software-defined networking for better bandwidth utilization and costs.',
        readTime: '13 min',
        tags: ['sdwan', 'networking'],
        icon: '🌍',
      },
      {
        id: 'sdwan-2',
        title: 'Multi-Site SD-WAN Deployment',
        excerpt: 'Deploy SD-WAN across multiple locations',
        content:
          'Configure SD-WAN for multi-site organizations. Establish secure, optimized connections between branches.',
        readTime: '15 min',
        tags: ['sdwan', 'multisite'],
        icon: '🔗',
      },
    ],
    'Managed Security': [
      {
        id: 'ms-1',
        title: 'SOC Monitoring and Response',
        excerpt: 'Security Operations Center services',
        content:
          'Access 24/7 SOC services. Monitor threats, respond to incidents, and maintain security posture.',
        readTime: '11 min',
        tags: ['security', 'soc'],
        icon: '🛡️',
      },
      {
        id: 'ms-2',
        title: 'Threat Intelligence and Reporting',
        excerpt: 'Advanced threat detection and analysis',
        content:
          'Receive threat intelligence and comprehensive security reports. Understand emerging threats and vulnerabilities.',
        readTime: '10 min',
        tags: ['security', 'intelligence'],
        icon: '📊',
      },
    ],
    'Enterprise SIP': [
      {
        id: 'esip-1',
        title: 'Enterprise SIP Trunk Management',
        excerpt: 'Advanced SIP configuration for enterprises',
        content:
          'Manage enterprise SIP trunks. Configure advanced call routing, failover, and load balancing.',
        readTime: '13 min',
        tags: ['voip', 'sip-enterprise'],
        icon: '☎️',
      },
    ],
    'Custom Integrations': [
      {
        id: 'ci-1',
        title: 'API Integration Development',
        excerpt: 'Build custom integrations with Talk Australia APIs',
        content:
          'Access our comprehensive API documentation. Develop custom integrations with your business systems.',
        readTime: '16 min',
        tags: ['api', 'integration'],
        icon: '⚙️',
      },
    ],
    'SLA Management': [
      {
        id: 'sla-1',
        title: 'SLA Tier Management',
        excerpt: 'Understand and manage your SLA commitments',
        content:
          'Overview of SLA tiers and commitments. Monitor uptime metrics and escalation procedures.',
        readTime: '8 min',
        tags: ['sla', 'support'],
        icon: '📋',
      },
    ],
  },
};

const VIDEOS = [
  {
    id: 'v1',
    title: 'Getting Started with Talk Australia',
    duration: '12:34',
    thumbnail: '🎬',
  },
  {
    id: 'v2',
    title: 'VoIP Setup and Configuration',
    duration: '8:45',
    thumbnail: '📹',
  },
  {
    id: 'v3',
    title: 'Advanced Network Management',
    duration: '15:20',
    thumbnail: '🎥',
  },
  {
    id: 'v4',
    title: 'Security Best Practices',
    duration: '10:15',
    thumbnail: '🎬',
  },
];

const TIER_FAQS = {
  smb: [
    {
      id: 'faq-1',
      question: 'What SLA uptime does SMB tier offer?',
      answer: '99.0% uptime guarantee with 24-hour support response time.',
    },
    {
      id: 'faq-2',
      question: 'How many users are included?',
      answer: 'SMB tier supports up to 50 users with full feature access.',
    },
  ],
  'mid-market': [
    {
      id: 'faq-1',
      question: 'What SLA uptime does Mid-Market tier offer?',
      answer: '99.5% uptime guarantee with 4-hour support response time.',
    },
    {
      id: 'faq-2',
      question: 'Are custom integrations available?',
      answer: 'Yes, Mid-Market includes basic API access for integrations.',
    },
  ],
  enterprise: [
    {
      id: 'faq-1',
      question: 'What SLA uptime does Enterprise tier offer?',
      answer: '99.99% uptime guarantee with 1-hour response time and dedicated support.',
    },
    {
      id: 'faq-2',
      question: 'Are there custom options?',
      answer:
        'Yes, Enterprise tier offers fully customizable solutions and dedicated account management.',
    },
  ],
};

export default function KnowledgeBaseNew() {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [selectedArticle, setSelectedArticle] = useState(null);

  // Get client tier from localStorage
  const clientData = (() => {
    try {
      const data = localStorage.getItem('ta_client_data');
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  })();

  const tier = clientData?.tier || 'smb';
  const normalizedTier = tier === 'mid-market' ? 'mid-market' : tier;

  // Get articles for this tier
  const getArticlesForTier = () => {
    const tierData = KNOWLEDGE_BASE[normalizedTier];
    const allArticles = Object.values(tierData).flat();
    return allArticles;
  };

  const allArticles = getArticlesForTier();

  // Filter articles based on search
  const filteredArticles = useMemo(() => {
    if (!searchQuery.trim()) return allArticles;

    const query = searchQuery.toLowerCase();
    return allArticles.filter(
      (article) =>
        article.title.toLowerCase().includes(query) ||
        article.excerpt.toLowerCase().includes(query) ||
        article.tags.some((tag) => tag.toLowerCase().includes(query))
    );
  }, [searchQuery, allArticles]);

  // Popular articles (first 4 unique ones)
  const popularArticles = allArticles.slice(0, 4);

  // FAQ for this tier
  const faqList = TIER_FAQS[normalizedTier] || [];

  // Get tier badge style
  const getTierBadgeStyle = () => {
    const baseStyle = { ...styles.tierBadge };
    if (normalizedTier === 'smb') return { ...baseStyle, ...styles.tierBadgeSmb };
    if (normalizedTier === 'mid-market') return { ...baseStyle, ...styles.tierBadgeMidMarket };
    return { ...baseStyle, ...styles.tierBadgeEnterprise };
  };

  const getTierLabel = () => {
    if (normalizedTier === 'mid-market') return 'Mid-Market';
    return normalizedTier.charAt(0).toUpperCase() + normalizedTier.slice(1);
  };

  return (
    <ClientShell title="Help Center">
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerTitle}>Help Center</div>
          <div style={styles.headerSubtitle}>
            Knowledge base for {getTierLabel()} tier customers
          </div>
        </div>

        {/* Search */}
        <div style={styles.searchContainer}>
          <div style={styles.searchWrapper}>
            <span style={styles.searchIcon}>🔍</span>
            <input
              style={{ ...styles.searchInput, ...styles.searchInputPlaceholder }}
              type="text"
              placeholder="Search articles, FAQs, and resources..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={(e) => {
                e.target.style.color = '#FFF';
              }}
            />
          </div>
        </div>

        {/* Popular Articles */}
        {!searchQuery && (
          <div style={styles.popularSection}>
            <div style={styles.sectionTitle}>
              <span>⭐</span> Popular Articles
            </div>
            <div style={styles.popularGrid}>
              {popularArticles.map((article) => (
                <div
                  key={article.id}
                  style={styles.articleCard}
                  onClick={() => setSelectedArticle(article)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = styles.articleCardHover.borderColor;
                    e.currentTarget.style.backgroundColor =
                      styles.articleCardHover.backgroundColor;
                    e.currentTarget.style.boxShadow = styles.articleCardHover.boxShadow;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#2A3444';
                    e.currentTarget.style.backgroundColor = '#0F1729';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={styles.articleIcon}>{article.icon}</div>
                  <div style={styles.articleTitle}>{article.title}</div>
                  <div style={styles.articleExcerpt}>{article.excerpt}</div>
                  <div style={styles.articleMeta}>
                    <div style={styles.readTime}>⏱️ {article.readTime}</div>
                  </div>
                  <div style={styles.tags}>
                    {article.tags.map((tag) => (
                      <span key={tag} style={styles.tag}>
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Search Results or Categories */}
        {searchQuery ? (
          <div style={styles.categoriesSection}>
            <div style={styles.sectionTitle}>Search Results ({filteredArticles.length})</div>
            {filteredArticles.length > 0 ? (
              <div style={styles.categoryGrid}>
                {filteredArticles.map((article) => (
                  <div key={article.id} style={styles.categoryBox}>
                    <div style={styles.categoryHeader}>
                      <div style={styles.categoryTitle}>{article.title}</div>
                    </div>
                    <div style={styles.categoryArticles}>
                      <div
                        style={styles.categoryArticleItem}
                        onClick={() => setSelectedArticle(article)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = '#0057FF';
                          e.currentTarget.style.backgroundColor = '#0F1729';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = 'transparent';
                          e.currentTarget.style.backgroundColor = '#0A0F1D';
                        }}
                      >
                        <div style={styles.categoryArticleTitle}>{article.excerpt}</div>
                        <div style={styles.categoryArticleDesc}>
                          {article.readTime} • {article.tags.join(', ')}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={styles.emptyState}>
                <div style={styles.emptyStateIcon}>🔍</div>
                <p>No articles found matching your search.</p>
              </div>
            )}
          </div>
        ) : (
          <div style={styles.categoriesSection}>
            <div style={styles.sectionTitle}>📚 Browse by Category</div>
            <div style={styles.categoryGrid}>
              {Object.entries(KNOWLEDGE_BASE[normalizedTier]).map(([category, articles]) => (
                <div key={category} style={styles.categoryBox}>
                  <div style={styles.categoryHeader}>
                    <div style={styles.categoryTitle}>{category}</div>
                    <div style={styles.categoryCount}>{articles.length} articles</div>
                  </div>
                  <div style={styles.categoryArticles}>
                    {articles.slice(0, 3).map((article) => (
                      <div
                        key={article.id}
                        style={styles.categoryArticleItem}
                        onClick={() => setSelectedArticle(article)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = '#0057FF';
                          e.currentTarget.style.backgroundColor = '#0F1729';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = 'transparent';
                          e.currentTarget.style.backgroundColor = '#0A0F1D';
                        }}
                      >
                        <div style={styles.categoryArticleTitle}>{article.title}</div>
                        <div style={styles.categoryArticleDesc}>
                          {article.readTime} • {article.tags.join(', ')}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Video Tutorials */}
        <div style={styles.videoSection}>
          <div style={styles.sectionTitle}>
            <span>🎬</span> Video Tutorials
          </div>
          <div style={styles.videoGrid}>
            {VIDEOS.map((video) => (
              <div
                key={video.id}
                style={styles.videoCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = styles.videoCardHover.borderColor;
                  e.currentTarget.style.transform = styles.videoCardHover.transform;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#2A3444';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={styles.videoThumbnail}>
                  <div
                    style={styles.playButton}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    ▶️
                  </div>
                </div>
                <div style={styles.videoMeta}>
                  <div style={styles.videoTitle}>{video.title}</div>
                  <div style={styles.videoDuration}>⏱️ {video.duration}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ Section */}
        <div style={styles.faqSection}>
          <div style={styles.sectionTitle}>
            <span>❓</span> Frequently Asked Questions
          </div>
          {faqList.map((faq) => (
            <div key={faq.id} style={styles.faqItem}>
              <div
                style={styles.faqQuestion}
                onClick={() => setExpandedFAQ(expandedFAQ === faq.id ? null : faq.id)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1A2332';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <div style={styles.faqQuestionText}>{faq.question}</div>
                <div style={styles.faqToggle}>{expandedFAQ === faq.id ? '−' : '+'}</div>
              </div>
              {expandedFAQ === faq.id && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        {/* Support CTA */}
        <div style={styles.supportSection}>
          <div style={styles.supportSectionTitle}>Can't find what you need?</div>
          <div style={styles.supportSectionText}>
            Our support team is here to help. Create a ticket and we'll get back to you shortly.
          </div>
          <button
            style={styles.supportButton}
            onClick={() => navigate('/client/tickets')}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = styles.supportButtonHover.backgroundColor;
              e.target.style.transform = styles.supportButtonHover.transform;
              e.target.style.boxShadow = styles.supportButtonHover.boxShadow;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#0057FF';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Create a Support Ticket →
          </button>
        </div>

        {/* Article Detail Modal */}
        {selectedArticle && (
          <div
            style={styles.detailModal}
            onClick={() => setSelectedArticle(null)}
          >
            <div
              style={styles.detailContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.detailHeader}>
                <div style={styles.detailTitle}>{selectedArticle.title}</div>
                <button
                  style={styles.closeButton}
                  onClick={() => setSelectedArticle(null)}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#FFF';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = '#8B92A5';
                  }}
                >
                  ✕
                </button>
              </div>

              <div style={styles.detailMeta}>
                <span>⏱️ {selectedArticle.readTime} read</span>
                <span>📚 {selectedArticle.tags.join(', ')}</span>
              </div>

              <div style={styles.detailBody}>
                {selectedArticle.content}
              </div>
            </div>
          </div>
        )}
      </div>
    </ClientShell>
  );
}
